import React from "react"
import Stack from "@mui/material/Stack"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"

function ProductActionBar(props: {
    onCreate: Function,
    onUpdate: Function,
    createDisabled: boolean,
    updateDisabled: boolean,
    sx?: object
}) {

    return (
        <Paper sx={props.sx}>
            <Stack direction="row" justifyContent="center" spacing={2} padding={2}>
                <Button variant="contained" disabled={props.createDisabled} onClick={() => props.onCreate()}>Create</Button>
                <Button variant="contained" disabled={props.updateDisabled} onClick={() => props.onUpdate()}>Update</Button>
            </Stack>
        </Paper>
    )
}

export default ProductActionBar